export const BRAND = {
  name: "Danseys Pass Lavender Farm",
  short: "Danseys Pass",
  tagline: "Stay somewhere quieter, wilder, and a little more unforgettable.",
  address: "1473 Danseys Pass Road, Danseys Pass, North Otago 9491, New Zealand",
  region: "North Otago · Aotearoa New Zealand",
};

// Your live Lodgify booking engine (channel manager). Used for all "Book" CTAs.
export const BOOKING_ENGINE_URL = "https://danseyspasslavenderfarm.com/en/all-properties/";

// Official Lodgify portable search bar (website id 665072). Renders the live availability
// search on the Book page; searches open the booking engine.
export const LODGIFY_WIDGET_SNIPPET = `
<style>
  :root {
    --ldg-psb-background: #ffffff;
    --ldg-psb-border-radius: 0.42em;
    --ldg-psb-box-shadow: 0px 24px 54px 0px rgba(0, 0, 0, 0.1);
    --ldg-psb-padding: 14px;
    --ldg-psb-input-background: #ffffff;
    --ldg-psb-button-border-radius: 3.58em;
    --ldg-psb-color-primary: #ab00fa;
    --ldg-psb-color-primary-lighter:#d580fd;
    --ldg-psb-color-primary-darker: #56007d;
    --ldg-psb-color-primary-contrast: #333333;
    --ldg-semantic-color-primary:  #ab00fa;
    --ldg-semantic-color-primary-lighter: #d580fd;
    --ldg-semantic-color-primary-darker: #56007d;
    --ldg-semantic-color-primary-contrast: #333333;
    --ldg-component-modal-z-index: 999;
  }
  #lodgify-search-bar {
    width:100%;
  }
</style>
<div
  id="lodgify-search-bar"
  data-website-id="665072"
  data-language-code="en"
  data-search-page-url='https://danseyspasslavenderfarm.com/en/all-properties'
  
  data-dates-check-in-label='Check-in'
  data-dates-check-out-label='Check-out'
  data-guests-counter-label='Guests'
  data-guests-input-singular-label='{{NumberOfGuests}} guest'
  data-guests-input-plural-label='{{NumberOfGuests}} guests'
  data-location-input-label='Location'
  data-search-button-label='Search'
  data-dates-input-min-stay-tooltip-text='{"one":"Minimum {minStay} night","other":"Minimum {minStay} nights"}'
  data-guests-breakdown-label='Guests'
  data-adults-label='{"one":"adult","other":"adults"}'
  data-adults-description='Ages {minAge} or above'
  data-children-label='{"one":"child","other":"children"}'
  data-children-description='Ages {minAge}-{maxAge}'
  data-children-not-allowed-label='Not suitable for children'
  data-infants-label='{"one":"infant","other":"infants"}'
  data-infants-description='Under {maxAge}'
  data-infants-not-allowed-label='Not suitable for infants'
  data-pets-label='{"one":"pet","other":"pets"}'
  data-pets-not-allowed-label='Not allowed'
  data-done-label='Done'
  
  data-new-tab="true"
  data-version="stable"
  data-has-guests-breakdown
  
></div>
<script src="https://app.lodgify.com/portable-search-bar/stable/renderPortableSearchBar.js" defer></script>
<style>
  :root {
    --ldg-psb-background: #121F18;
    --ldg-psb-border-radius: 1.1em;
    --ldg-psb-box-shadow: 0px 24px 54px 0px rgba(0, 0, 0, 0.35);
    --ldg-psb-padding: 14px;
    --ldg-psb-input-background: #0B120E;
    --ldg-psb-button-border-radius: 3.58em;
    --ldg-psb-color-primary: #C4B5FD;
    --ldg-psb-color-primary-lighter: #D9CCFE;
    --ldg-psb-color-primary-darker: #A78BFA;
    --ldg-psb-color-primary-contrast: #0B120E;
    --ldg-semantic-color-primary: #C4B5FD;
    --ldg-semantic-color-primary-lighter: #D9CCFE;
    --ldg-semantic-color-primary-darker: #A78BFA;
    --ldg-semantic-color-primary-contrast: #0B120E;
  }
</style>`;

// Official Lodgify Book Now box (rental id 825000, website id 665072) — dates + live total
// price + Book Now (secure Lodgify checkout, opens in new tab).
export const LODGIFY_BOOK_NOW_SNIPPET = `
<style>
  :root {
    --ldg-bnb-background: #ffffff;
    --ldg-bnb-border-radius: 0.42em;
    --ldg-bnb-box-shadow: 0px 24px 54px 0px rgba(0, 0, 0, 0.1);
    --ldg-bnb-padding: 14px;
    --ldg-bnb-input-background: #ffffff;
    --ldg-bnb-button-border-radius: 3.58em;
    --ldg-bnb-color-primary: #fac600;
    --ldg-bnb-color-primary-lighter:#fde380;
    --ldg-bnb-color-primary-darker: #7d6300;
    --ldg-bnb-color-primary-contrast: #333333;
    --ldg-component-calendar-cell-selection-bg-color: #fac600;
    --ldg-component-calendar-cell-selection-color: #333333;
    --ldg-component-calendar-cell-selected-bg-color: #fde380;
    --ldg-component-calendar-cell-selected-color: #333333;
    --ldg-bnb-font-family: inherit;
  }
  #lodgify-book-now-box {
    width: 100%;
  }
</style>
<div
  id="lodgify-book-now-box"
  data-rental-id="825000"
  data-website-id="665072"
  data-slug="danseyspasslavenderfarm"
  data-language-code="en"
  data-new-tab="true"
  data-version="stable"
  data-has-guests-breakdown
  data-check-in-label='Check-in'
  data-check-out-label='Check-out'
  data-guests-label='Guests'
  data-guests-singular-label='{{NumberOfGuests}} guest'
  data-guests-plural-label='{{NumberOfGuests}} guests'
  data-location-input-label='Location'
  data-total-price-label='Total price:'
  data-select-dates-to-see-price-label='Select dates to see total price'
  data-minimum-price-per-night-first-label='From'
  data-minimum-price-per-night-second-label='per night'
  data-book-button-label='Book Now'
  data-guests-breakdown-label='Guests'
  data-adults-label='{"one":"adult","other":"adults"}'
  data-adults-description='Ages {minAge} or above'
  data-children-label='{"one":"child","other":"children"}'
  data-children-description='Ages {minAge}-{maxAge}'
  data-children-not-allowed-label='Not suitable for children'
  data-infants-label='{"one":"infant","other":"infants"}'
  data-infants-description='Under {maxAge}'
  data-infants-not-allowed-label='Not suitable for infants'
  data-pets-label='{"one":"pet","other":"pets"}'
  data-pets-not-allowed-label='Not allowed'
  data-done-label='Done'
></div>
<script src="https://app.lodgify.com/book-now-box/stable/renderBookNowBox.js" defer></script>
<style>
  :root {
    --ldg-bnb-background: #121F18;
    --ldg-bnb-border-radius: 1.1em;
    --ldg-bnb-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
    --ldg-bnb-padding: 14px;
    --ldg-bnb-input-background: #0B120E;
    --ldg-bnb-button-border-radius: 3.58em;
    --ldg-bnb-color-primary: #C4B5FD;
    --ldg-bnb-color-primary-lighter: #D9CCFE;
    --ldg-bnb-color-primary-darker: #A78BFA;
    --ldg-bnb-color-primary-contrast: #0B120E;
    --ldg-component-calendar-cell-selection-bg-color: #A78BFA;
    --ldg-component-calendar-cell-selection-color: #0B120E;
    --ldg-component-calendar-cell-selected-bg-color: #C4B5FD;
    --ldg-component-calendar-cell-selected-color: #0B120E;
  }
  #lodgify-book-now-box { width: 100%; }
</style>`;

// Official Lodgify Book Now box — rental id 825001 (Karearea, Dome 02).
export const LODGIFY_BOOK_NOW_SNIPPET_825001 = `
<style>
  :root {
    --ldg-bnb-background: #ffffff;
    --ldg-bnb-border-radius: 0.42em;
    --ldg-bnb-box-shadow: 0px 24px 54px 0px rgba(0, 0, 0, 0.1);
    --ldg-bnb-padding: 14px;
    --ldg-bnb-input-background: #ffffff;
    --ldg-bnb-button-border-radius: 3.58em;
    --ldg-bnb-color-primary: #fac600;
    --ldg-bnb-color-primary-lighter:#fde380;
    --ldg-bnb-color-primary-darker: #7d6300;
    --ldg-bnb-color-primary-contrast: #333333;
    --ldg-component-calendar-cell-selection-bg-color: #fac600;
    --ldg-component-calendar-cell-selection-color: #333333;
    --ldg-component-calendar-cell-selected-bg-color: #fde380;
    --ldg-component-calendar-cell-selected-color: #333333;
    --ldg-bnb-font-family: inherit;
  }
  #lodgify-book-now-box {
    width: 100%;
  }
</style>
<div
  id="lodgify-book-now-box"
  data-rental-id="825001"
  data-website-id="665072"
  data-slug="danseyspasslavenderfarm"
  data-language-code="en"
  data-new-tab="true"
  data-version="stable"
  data-has-guests-breakdown
  data-check-in-label='Check-in'
  data-check-out-label='Check-out'
  data-guests-label='Guests'
  data-guests-singular-label='{{NumberOfGuests}} guest'
  data-guests-plural-label='{{NumberOfGuests}} guests'
  data-location-input-label='Location'
  data-total-price-label='Total price:'
  data-select-dates-to-see-price-label='Select dates to see total price'
  data-minimum-price-per-night-first-label='From'
  data-minimum-price-per-night-second-label='per night'
  data-book-button-label='Book Now'
  data-guests-breakdown-label='Guests'
  data-adults-label='{"one":"adult","other":"adults"}'
  data-adults-description='Ages {minAge} or above'
  data-children-label='{"one":"child","other":"children"}'
  data-children-description='Ages {minAge}-{maxAge}'
  data-children-not-allowed-label='Not suitable for children'
  data-infants-label='{"one":"infant","other":"infants"}'
  data-infants-description='Under {maxAge}'
  data-infants-not-allowed-label='Not suitable for infants'
  data-pets-label='{"one":"pet","other":"pets"}'
  data-pets-not-allowed-label='Not allowed'
  data-done-label='Done'
></div>
<script src="https://app.lodgify.com/book-now-box/stable/renderBookNowBox.js" defer></script>
<style>
  :root {
    --ldg-bnb-background: #121F18;
    --ldg-bnb-border-radius: 1.1em;
    --ldg-bnb-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
    --ldg-bnb-padding: 14px;
    --ldg-bnb-input-background: #0B120E;
    --ldg-bnb-button-border-radius: 3.58em;
    --ldg-bnb-color-primary: #C4B5FD;
    --ldg-bnb-color-primary-lighter: #D9CCFE;
    --ldg-bnb-color-primary-darker: #A78BFA;
    --ldg-bnb-color-primary-contrast: #0B120E;
    --ldg-component-calendar-cell-selection-bg-color: #A78BFA;
    --ldg-component-calendar-cell-selection-color: #0B120E;
    --ldg-component-calendar-cell-selected-bg-color: #C4B5FD;
    --ldg-component-calendar-cell-selected-color: #0B120E;
  }
  #lodgify-book-now-box { width: 100%; }
</style>`;

export const DOMES = [
  {
    id: "piwakawaka",
    number: "Dome 01",
    name: "Piwakawaka",
    fullName: "Mountain View Dome with Private Hot Tub",
    tagline: "A cosy, rustic geodesic dome with sweeping Danseys Pass views and a private hot tub.",
    blurb:
      "Inside you'll find a king bed with quality cotton linen, a comfy couch, wood-burning fireplace, private bathroom and bunk beds for children. The kitchenette includes induction cooking, microwave, air fryer and fridge. Outside, enjoy the rustic shower, peaceful mountain views and a relaxed high-country escape.",
    specs: ["Sleeps 4", "1 bedroom", "5 beds", "1 bathroom", "From €141 per night"],
    amenities: ["King bed", "Private hot tub", "Wood-burning fireplace", "Bunk beds for children", "Private bathroom", "Kitchenette", "Rustic outdoor shower", "Mountain views", "Heating"],
    img: "/images/piwakawaka-cover.jpg",
    rating: "5.0",
    reviews: 70,
    gallery: [
      "/images/piwakawaka-g01.jpg",
      "/images/piwakawaka-g02.jpg",
      "/images/piwakawaka-g03.jpg",
      "/images/piwakawaka-g04.jpg",
      "/images/piwakawaka-g05.jpg",
      "/images/piwakawaka-g06.jpg",
      "/images/piwakawaka-g07.jpg",
      "/images/piwakawaka-g08.jpg",
      "/images/piwakawaka-g09.jpg",
      "/images/piwakawaka-g10.jpg",
      "/images/piwakawaka-g11.jpg",
    ],
  },
  {
    id: "karearea",
    number: "Dome 02",
    name: "Kārearea",
    fullName: "Luxury Dome with Hot Tub",
    tagline: "A spacious geodesic dome with panoramic mountain views, a private stainless-steel and cedar hot tub, and an outdoor deck with BBQ.",
    blurb:
      "Inside you'll find wool carpet, comfortable couches, a king bed with quality cotton linen, plus two singles that can convert to a queen. The fully equipped kitchen includes induction cooking, microwave, air fryer and fridge, while heating and air conditioning keep the dome comfortable year-round.",
    specs: ["Sleeps 4", "1 bedroom", "6 beds", "1 bathroom", "From €149 per night"],
    amenities: ["King bed", "Stainless-steel & cedar hot tub", "Outdoor deck with BBQ", "Wool carpet", "Singles convert to queen", "Fully equipped kitchen", "Heating & air conditioning", "Hammock & fire pit", "Outdoor shower"],
    img: "/images/karearea-cover.jpg",
    rating: "5.0",
    reviews: 39,
    gallery: [
      "/images/karearea-g01.jpg",
      "/images/karearea-g02.jpg",
      "/images/karearea-g03.jpg",
      "/images/karearea-g04.jpg",
      "/images/karearea-g05.jpg",
      "/images/karearea-g06.jpg",
      "/images/karearea-g07.jpg",
      "/images/karearea-g08.jpg",
      "/images/karearea-g09.jpg",
      "/images/karearea-g10.jpg",
      "/images/karearea-g11.jpg",
    ],
  },
];

export const IMAGES = {
  hero: "/images/domes-sunset.jpg",
  overview: "/images/overview.jpg",
  domePortrait: "/images/dome-portrait.jpg",
  domeInterior: "/images/dome-interior.jpg",
  hottub: "/images/hottub.jpg",
  sauna: "/images/sauna.jpg",
  lavender: "/images/lavender.jpg",
  harvest: "/images/harvest.jpg",
  horses: "/images/horses.jpg",
  frost: "/images/frost.jpg",
  snow: "/images/domes-snow.jpg",
  nightSky: "/images/night-sky.jpg",
  oteake: "/images/oteake.jpg",
  dogLavender: "/images/dog-lavender.jpg",
  piwakawakaCover: "/images/piwakawaka-cover.jpg",
  piwakawakaInterior: "/images/piwakawaka-interior.jpg",
  piwakawakaBed: "/images/piwakawaka-bed.jpg",
  kareareaCover: "/images/karearea-cover.jpg",
  kareareaDeck: "/images/karearea-deck.jpg",
};


const BOOKING_REVIEWS = [
  {
    name: "Becky",
    country: "Australia",
    title: "Stunning place!",
    quote:
      "Absolutely spectacular place, stunning views. Would never call this glamping, it was lush. Hot tub with views was cherry on the cake, dome was super spacious and had everything we needed. Even got delivered fresh eggs, bread, milk and butter in morning. Was perfect!! Would 100% come back!",
    dome: "Dome Kārearea",
    stay: "1 night · January 2026 · Couple",
    score: "10",
  },
  {
    name: "Séverine",
    country: "New Zealand",
    title: "The perfect spot for a peaceful retreat.",
    quote:
      "We absolutely loved our stay and are already planning our return to the lavender farm! Beautiful remote location and we absolutely loved all the little details in the dome, a perfect spot if you want to get away from it all and fully disconnect. Biggest highlights for us were sitting in the hot tub under the rain, watching the views and the reflection of the “sphere lamps” onto the glass windows at dusk and of course the scrumptious fresh bread that our lovely host Hugh delivered to our door in the morning :)",
    dome: "Dome Kārearea",
    stay: "1 night · January 2026 · Couple",
    score: "10",
  },
  {
    name: "Samantha",
    country: "New Zealand",
    title: "This place is pure heaven !!!",
    quote:
      "The domes and environment are tranquil and so relaxing. The moment you walk in the dome you just feel a huge sigh leave your body. Instant relaxation. The hot tub, river and views were stunning. Loved everything about it.",
    dome: "Dome Kārearea",
    stay: "2 nights · January 2026 · Couple",
    score: "10",
  },
  {
    name: "Peter",
    country: "United Kingdom",
    title: "A special place on the Dansey's Pass to stay",
    quote:
      "We really enjoyed our stay in the Lavender Farm Dome, everything provided to make our stay very comfortable and a memorable experience. The private hot tub was a great touch and fresh bread, milk, butter and eggs in the morning just made it the perfect place to spend the night. The views were spectacular, the remoteness and peace, fantastic. Just wish we could have stayed longer. Special thanks to Hugh and Tim for their hospitality.",
    dome: "Dome Piwakawaka",
    stay: "1 night · February 2026 · Couple",
    score: "10",
  },
  {
    name: "Grant",
    country: "Canada",
    title: "A perfect retreat to refresh you and your family.",
    quote:
      "This place is a hidden gem. Our family of 4 stayed for 2 nights and were blown away. Our favourite things about it: the beauty of the location, the serene view from our dome, our own private hot tub, the friendly animals (dog, horses, sheep) and the hospitality of our hosts. We got warm bread & butter delivered both mornings, and even got some fresh milk to add to our tea/coffee! Locals from Queenstown or Christchurch should definitely come here for a weekend getaway! If we come back to NZ, we would 100% go back. 10/10. Well done.",
    dome: "Dome Kārearea",
    stay: "2 nights · January 2026 · Family",
    score: "10",
  },
  {
    name: "Kaye",
    country: "New Zealand",
    title: "Awesome experience, spa was amazing,!!",
    quote:
      "Great adventure, dome had everything you need and was exceptional very very clean. Would love to stay again",
    dome: "Dome Kārearea",
    stay: "1 night · May 2026 · Couple",
    score: "10",
  },
  {
    name: "Suellen",
    country: "New Zealand",
    title: "Incredible stay one night won't be enough",
    quote:
      "This is a dream of a stay. The details to make it so easy to relax and outdoor sauna and also private spa incredible",
    dome: "Dome Piwakawaka",
    stay: "1 night · June 2026 · Couple",
    score: "10",
  },
  {
    name: "Olivia",
    country: "Australia",
    title: "Exceptional",
    quote:
      "Was such a beautiful peaceful stay, had everything you needed, was such a wholesome experience would definitely recommend, it is a remote stay but definitely worth it !!!! Was really clean and spacious with a super comfy bed and had super unique and cool features!",
    dome: "Dome Kārearea",
    stay: "1 night · August 2026 · Couple",
    score: "10",
  },
  {
    name: "Elizaveta",
    country: "New Zealand",
    title: "What a hidden gem!",
    quote:
      "This must be one of the best places I have ever stayed at. Breathtaking secluded location, sauna by the river, hot tub at your dome's doorstep under the stars, and the dome itself is so comfortable. Everything is thought through in little details—there are books, board games, selection of herbal teas and good plunger coffee, there is even an air fryer at the kitchen! Anything you could possibly think of for an absolutely relaxed getaway, the hosts have already thought about and arranged. The amount of dopamine I got from just being there, walking around, reading a book with magnificent Danseys Pass views cannot be described with words! Thank you so much for your warm hospitality and creating such a wonderful relaxing place.",
    dome: "Dome Kārearea",
    stay: "1 night · September 2026 · Couple",
    score: "10",
  },
];

const AIRBNB_REVIEWS = [
  {
    name: "Marie",
    country: null,
    title: null,
    quote:
      "This was our second stay here and it was just as wonderful as the first. We love the serene surroundings, cosy accommodations, and welcoming hosts. Prepare for incredible stargazing (all from the warmth of the hot tub). The domes make for a lovely stay — waking up to a view of the valley and mountains each morning is an absolute delight. We plan to visit again (and again, and again) for a peaceful retreat!",
    dome: null,
    stay: "Stayed May 2026",
    source: "Airbnb",
  },
  {
    name: "Mark",
    country: null,
    title: null,
    quote:
      "Absolutely amazing. From the views to the high-quality furnishings and superbly kitted out kitchen, amazing hot tub, wonderful outdoor shower, an absolute adventure and brilliant in every way!!",
    dome: null,
    stay: "Stayed July 2026",
    source: "Airbnb",
  },
  {
    name: "Brad",
    country: null,
    title: null,
    quote:
      "Such a wonderful way to spend a night or two. Domes were amazing. Spa next to our dome was perfect for star gazing, and having a beer after a long day. Rooms was spotless but had all the gizmo's and gadgets I would expect of a modern city apartment.",
    dome: null,
    stay: "Stayed June 2026",
    source: "Airbnb",
  },
  {
    name: "Kim",
    country: null,
    title: null,
    quote:
      "If I could give this 6 stars I would. I highly recommend this place, it's such a special spot. Everything is well thought off and comfortable. I wish we could have stayed more than just one night. We will definitely be back.",
    dome: null,
    stay: "Stayed August 2026",
    source: "Airbnb",
  },
  {
    name: "Robert",
    country: "California, United States",
    title: null,
    quote:
      "Beautiful place, really well designed and thoughtfully stocked with amenities. Really enjoyed my stay and would highly recommend!",
    dome: null,
    stay: "Stayed August 2026",
    source: "Airbnb",
  },
  {
    name: "Roscoe",
    country: null,
    title: null,
    quote:
      "An amazing stay, friendly host, beautiful scenery and accomodation. Would highly recommend!",
    dome: null,
    stay: "Stayed July 2026",
    source: "Airbnb",
  },
  {
    name: "Nadia",
    country: null,
    title: null,
    quote:
      "This was the most amazing experience we've ever had! We will absolutely be back. Tim and Hugh were there to greet us warmly, the location is peaceful and healing. We swam in the river, got pats with the horses, strolled through the lavender. The spa and view was amazing! The outdoor shower was so good and the bed so comfy. We are just blown away by the hospitality and everything that was provided. Rumi is the sweetest dog who wished us farewell when we left. Couldn't recommend highly enough. Definitely a trip to remember! Thank you for everything Tim and Hugh!",
    dome: null,
    stay: "Stayed August 2026",
    source: "Airbnb",
  },
  {
    name: "Poppy",
    country: null,
    title: null,
    quote:
      "What an absolutely beautiful place, this has probably been one of my favorite stays in all my travels around the world! It's so clean and fresh the views are unbelievable it's just a slice of heaven, bed was comfy shower was sooo nice and the hot tub to top it off!! I could not recommend this place more. If you are looking to switch off this is the place to go!",
    dome: null,
    stay: "Stayed August 2026",
    source: "Airbnb",
  },
  {
    name: "Arabella",
    country: null,
    title: null,
    quote: "The most magical couple of nights away! Cannot recommend staying here enough",
    dome: null,
    stay: "Stayed August 2026",
    source: "Airbnb",
  },
];

export const REVIEWS = [
  ...BOOKING_REVIEWS.map((r) => ({ ...r, source: "Booking.com" })),
  ...AIRBNB_REVIEWS,
];
